import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 9,
      rows: 3,
      colSpan: {
        "0:0": 9,
        "2:1": 2,
        "2:4": 2,
        "2:7": 2,
      },
      rowSpan: {
        "1:0": 2,
        "1:3": 2,
        "1:6": 2,
      },
      rowsSize: [4.5, 0.3, 1],
      colsSize: [1.5, 0.5, 1.3, 1.5, 0.5, 1.3, 1.5, 0.5, 1.3],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/straw-house.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/straw-bales.png`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/straw-1.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingLeft: "5%",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/straw-base-boards.png`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/straw-2.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingLeft: "5%",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/straw-and-clay-based-plaster.png`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/straw-3.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingLeft: "5%",
              },
            },
          },
          null,
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Straw bales</b> having porous absorption properties",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3%",
                justifyContent: "flex-start",
              },
            },
          },
          null,
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Straw base boards</b> giving some mass to be used as a light-weight partition",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3%",
                justifyContent: "flex-start",
              },
            },
          },
          null,
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Straw and clay-based plaster</b> used for coat finishes and airtightness",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3%",
                justifyContent: "flex-start",
              },
            },
          },
        ],
      ],
    },
  },
};

export default components;
